export enum Actuality {
    Actual = 1,
    NeedRecalculation,
    CalculationInProcess
}

export function getCalculationStatusActualityById(actualityId: number): string {
    return ['', 'Actual', 'Need recalculation', 'Calculation in process'][
        actualityId
    ];
}
